module.exports = __webpack_public_path__ + "img/shotgun.pump.842a75b8.png";